import { Injectable } from '@angular/core';
import {
  idNameItem,
  jkLib,
  jkRestReturn,
} from 'jk-service';
import { StkleServicePkg } from './stklePkg.service';
import { Stkle } from '../entity/Stkle-angular';
import { OrmService } from 'jk-service';

export const StkLe008List: idNameItem[] = [
  { id: '1', name: '1:未讀' },
  { id: '2', name: '2:全部' },
];

@Injectable({
  providedIn: 'root',
})
export class StkleService extends StkleServicePkg {
  le010Filter(type: number): string {
    let s = '';
    if (type === 0) {// 自訂價格
      s = 'TM110,TM111,TM112,TM113,TM114,TM115,TM116,TM117,TM118,TM119';
    } else if (type === 1) {// 自訂追蹤.實際用stkmj
      s = 'TM015,TM016,TM017,TM018,TM019,TM020,TM021,TM022';
    }
    return s;
  }
  le010FilterKind: idNameItem[] = [];
  constructor() {
    super();

    let item = '0:自訂價格,1:自訂追蹤,2:全部';
    this.le010FilterKind = this.colonString2IdNameItem(item, ',');
  }
  async stockChange(xType: string, le008: string, xDate: string, xStockno: string, le010Filter: string) {
    if (xType === '1') { // 股票代號
      this.sqlWhere = ` AND LE003='${xStockno}' `;
      if (le008 === '1') // 未讀
        this.sqlWhere = this.sqlWhere + ` AND LE008='N' `;
      this.sqlWhere = jkLib.comma2Where(le010Filter, this.sqlWhere, 'LE010');
      this.sqlOrder = ' ORDER BY LE001 DESC,LE002 DESC,LE011 DESC';
      /*this.sqlSelect =
        ' SELECT TOP 200 LE001 AS 日期,LE002 AS [時間],LE006 AS [商品名稱],LE004 AS [條件名稱],LE013 AS [價格],'
        + CR + ' LE007 AS 內容,LE008 AS [已讀],LE010 AS  條件代號,LE012  AS  已說次數,LE003 AS [商品代號],LE001+LE002 AS KEY1' +CR+
        ' FROM STKLE ' + CR + this.sqlWhere + CR +
        ' ORDER BY LE001 DESC,LE002 DESC,LE011 DESC';*/
    }
    if (xType === '2') { // 日期
      this.sqlWhere = ` AND LE001='${xDate}' `;
      this.sqlWhere = jkLib.comma2Where(le010Filter, this.sqlWhere, 'LE010');
      if (le008 === '1') // 未讀
        this.sqlWhere = this.sqlWhere + ` AND LE008='N' `;
      this.sqlOrder = ' ORDER BY LE002 DESC,LE011 DESC';
      /*this.sqlSelect =
        ' SELECT TOP 200 LE001 AS 日期,LE002 AS [時間],LE006 AS [商品名稱],LE004 AS [條件名稱],LE013 AS [價格],'
        + CR + ' LE007 AS 內容,LE008 AS [已讀],LE010 AS  條件代號,LE012  AS  已說次數,LE003 AS [商品代號],LE001+LE002 AS KEY1' +CR+
        ' FROM STKLE ' + CR + this.sqlWhere + CR +
        ' ORDER BY LE002 DESC,LE011 DESC';*/
    }
    if (xType === '3') { // 最近500筆
      this.sqlWhere = `  `;
      if (le008 === '1') // 未讀
        this.sqlWhere = this.sqlWhere + ` AND LE008='N' `;
      this.sqlWhere = jkLib.comma2Where(le010Filter, this.sqlWhere, 'LE010');
      this.sqlOrder = ' ORDER BY LE001 DESC,LE002 DESC,LE011 DESC';
    }

    await this.doRefresh();

  }
  async incCount(item: Stkle) {
    item.LE012 = item.LE012 + 1;
    let keyV = this.getKeyValues(item);
    await this.updateData(keyV, item);
  }
  async deleteStock(date: string, stockno: string): Promise<jkRestReturn> {
    let sql = `DELETE FROM STKLE WHERE LE001='${date}' AND LE003='${stockno}'`;
    return await this.orm.transactionOneSql(sql);
  }
}
